import React from 'react';

const Trophy = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.66667 17.5H13.3333M10 14.1667V17.5M10 14.1667C11.1051 14.1667 12.1649 13.7277 12.9463 12.9463C13.7277 12.1649 14.1667 11.1051 14.1667 10V3.33337H5.83333V10C5.83333 11.1051 6.27232 12.1649 7.05372 12.9463C7.83512 13.7277 8.89493 14.1667 10 14.1667ZM2.5 7.50004C2.5 7.94207 2.67559 8.36599 2.98816 8.67855C3.30072 8.99111 3.72464 9.16671 4.16667 9.16671C4.60869 9.16671 5.03262 8.99111 5.34518 8.67855C5.65774 8.36599 5.83333 7.94207 5.83333 7.50004C5.83333 7.05801 5.65774 6.63409 5.34518 6.32153C5.03262 6.00897 4.60869 5.83337 4.16667 5.83337C3.72464 5.83337 3.30072 6.00897 2.98816 6.32153C2.67559 6.63409 2.5 7.05801 2.5 7.50004ZM14.1667 7.50004C14.1667 7.94207 14.3423 8.36599 14.6548 8.67855C14.9674 8.99111 15.3913 9.16671 15.8333 9.16671C16.2754 9.16671 16.6993 8.99111 17.0118 8.67855C17.3244 8.36599 17.5 7.94207 17.5 7.50004C17.5 7.05801 17.3244 6.63409 17.0118 6.32153C16.6993 6.00897 16.2754 5.83337 15.8333 5.83337C15.3913 5.83337 14.9674 6.00897 14.6548 6.32153C14.3423 6.63409 14.1667 7.05801 14.1667 7.50004Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Trophy };
//# sourceMappingURL=Trophy.js.map
